const baseUrl = {
  v1: '/getapi/v1.0.0',
  v2: '/getapi/v1.1.0',
  v3: '/getapi/v1.2.0',
  v22:'/getapi/v2',
  vwang: '/vwang/v1',
  vli:'/vli/v1',
  vtopic: '/vtopic/v1.0.0',
  genericV1:'/genericV1/v2'
}

export default baseUrl
